// extracted by mini-css-extract-plugin
export default {"table_border":"Statement_table_border__84XGU","page-break":"Statement_page-break__GqjYS"};